import styled from '@emotion/styled'
import { AppBar, IconButton, Typography } from '@mui/material'

export const HeaderWrapper = styled.div`
  width: 100%;
  margin: 0 0 26px 0;
`

export const MojovaAppBar = styled(AppBar)`
  background: #303030;
  box-shadow:
    0 0 4px 0 rgba(0, 0, 0, 0.12),
    0 4px 4px 0 rgba(0, 0, 0, 0.24);
`

export const HeaderTitle = styled(Typography)`
  flex-grow: 1;
  font-size: 22px;
  text-align: left;
  line-height: 28px;
  margin-left: 15px;
`

export const HeaderBackButton = styled(IconButton)`
  margin-left: -10px;
`

export const MenuButton = styled(IconButton)`
  margin-left: -10px;
`
